import React from 'react';
import { ModuleInterface } from '../types';
import { Radio } from 'ui';

interface RadioFieldProps extends ModuleInterface {}

const RadioField: React.FC<RadioFieldProps> = ({ layout, ...field }) => {
    const commonProps = {
        url: field.endpoint,
        label: field.label,
        name: field.name,
        labelInValue: true,
        customLayout: layout,
        method: field?.method ?? 'GET',
        translation: field?.translation ?? '',
        validation: { required: field.required ?? false },
    };

    return <Radio {...commonProps}  />;
};

export default RadioField;
